<template>
  <div ref="wrap" :style="wrapStyle">
    <canvas ref="canvas" class="pag-canvas" :id="`pag-${this.uid}`" v-show="isDefault"></canvas>
    <c-dialog v-model="isDefault" :option="option">
      <template slot="body">
        <div ref="canvasBox" :style="canvasBoxStyle"></div>
      </template>
    </c-dialog>
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-public-reward-box v-bind="$props" ref="rewardBox"></c-public-reward-box>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
import CPublicRewardBox from '@tencent/ceiba-act-public-reward-box';
const DEFAULT_PAG_FILE = 'https://act.xinyue.qq.com/assets/pag/like.pag';
// const DEFAULT_PAG_FILE = 'src/components/commercial-repeatedly-lottery/like.pag';
export default {
  name: 'CCommercialRepeatedlyLottery',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
    [CPublicRewardBox.name]: CPublicRewardBox,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'commercial-repeatedly-lottery-',
      packageName: '',
      isShow: false,
      showImage: false,
      isShowDynamicEffectDialog: false, // 弹框展示与否
      packageImgArr: [], // 活动奖励图片列表
      surplusLotteryTimes: 200, // 剩余抽奖次数
      onceOrtimesFlag: true, // 一次或多次抽奖数量控制变量
      count: 0,
      isDefault: false,
      pag: null,
      pagView: null,
      pagCanvas: null,
      pagFile: null,
      pagWidth: 0,
      pagHeight: 0,
      pagHWRatio: 0,
      resizeCoolDown: null,
    };
  },
  computed: {
    option() {
      return Object.assign({}, this.dialogConfig, {
        header: false,
        fotter: false,
        close: false,
        maskClickable: false,
        dialogStyle: {
          backgroundImage: ' ',
          backgroundColor: 'transparent',
          display: 'block',
        },
      });
    },
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    computedStyle() {
      if (this.enable) {
        return {
          backgroundImage: `url(${encodeURI(this.configurationData.rewardImg)})`,
        };
      }
      return {
        backgroundImage: `url(${encodeURI(this.configurationData.rewardedImg)})`,
      };
    },
    canvasBoxStyle() {
      return {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return true;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.surplusLotteryTimes = packageStatus.remain;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
  },
  async mounted() {
    // 实例化 PAG
    // this.pag = await window.libpag?.PAGInit();
    const that = this;
    this.$nextTick(async () => {
      // await this.createPAGView();
      window.addEventListener(
        'PAGInitReady',
        (e) => {
          console.log('PAGInitReady', e);
          that.pag = window.PAG;
          // 初始化 pag canvas 避免多个按钮使用 欧皇模式影响
          // 仅开启动画时初始加载
          if (this.configurationData?.lotteryPag) {
            that.createPAGView();
          }
        },
        {
          once: true,
        },
      );
    });
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    initialize() {
      // 强制不需要角色 解决不删档领取积分到游戏openid账号上
      const  { forbiddenRequireRole = false } =  this.configurationData;
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: forbiddenRequireRole === true ?  false : this.configurationData.forceRole,
      });
    },
    closeBtnClick() {
      this.isShow = false;
    },
    async doReward() {
      this.packageName = ''; // 置空
      let lotteryNums = 0;
      if (this.configurationData?.queryLotteryNumFlowId) {
        const lotteryNumResponse = await this.flowRequest({
          flowId: this.configurationData.queryLotteryNumFlowId,
        });
        lotteryNums = lotteryNumResponse?.data?.useNum || lotteryNumResponse?.data?.remain
          || lotteryNumResponse?.data?.value;
      }
      const num = parseInt(this.configurationData.lotteryNum, 10);

      const options = {
        carryRoleFlag: true,
      };
      const params = {
        role: this.roleInfo,
        data: JSON.stringify({
          pNum: num,
        }),
      };
      const  { forbiddenRequireRole = false } =  this.configurationData;
      // 禁止强制传角色
      if  (forbiddenRequireRole === true) {
        params.role = {};
        options.carryRoleFlag = false;
      }
      let response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params,
        options,
      });
      response = this.$refs.rewardBox.handlerLotteryModeResponse(response);
      console.log('【CCommercialRepeatedlyLottery】doReward response = ', response);
      await this.refreshQua(); // 刷新礼包
      this.handleClickEvent();
      if (response.ret !== 0) {
        this.alert(response.data.msg || response.msg);
      } else if (response.ret === 0) {
        if (response?.data?.ret === 0) {
          await this.showNewPop(response, lotteryNums);
        } else {
          this.alert(response.data.msg || response.msg);
        }
      }
    },
    /**
     * 调用欧皇新弹窗
     * @param responseData
     * @returns {Promise<void>}
     */
    async showNewPop(responseData, nums) {
      const that = this;
      const iconArr = {
        packageConfig: {},
        displayConfig: {},
      };
      let headerText = '恭喜获得';
      let ripsText = '';
      if (parseInt(responseData.data.package_id, 10)
        === parseInt(this.configurationData?.displayConfig?.defaultGiftId, 10)) {
        headerText = '温馨提示';
        ripsText = this.configurationData?.ripsText;
      }
      this.$set(iconArr, 'packageConfig', this.configurationData.giftIconList);
      this.$set(iconArr.displayConfig, 'lotteryPlayType', this.configurationData.lotteryPlayType);
      this.$set(iconArr.displayConfig, 'headerText', headerText);
      this.$set(iconArr.displayConfig, 'ripsText', ripsText);
      this.$set(iconArr.displayConfig, 'lotteryNum', nums);
      const metaData = this.$refs.rewardBox.buildMetaData(iconArr, responseData);
      console.log(metaData);
      if (this.configurationData.lotteryPag) {
        this.isDefault = true;
        // 将canvas移动到弹窗内
        this.$nextTick(async () => {
          this.$refs.canvasBox.appendChild(this.$refs.canvas);
          await this.createPAGView();
        });
        // await this.pagView?.play();
        setTimeout(() => {
          this.$refs.wrap.appendChild(this.$refs.canvas);
          this.isDefault = false;
          // that.pagView?.stop();
          that.$refs.rewardBox.showPop(metaData);
        }, this.configurationData.pagDuration || 1000);
      } else {
        await this.$refs.rewardBox.showPop(metaData);
      }
    },
    async createPAGView() {
      const that = this;
      // 清除上一个 PAG 相关的资源
      let newPagFile = null;
      // 获取 PAG 素材数据
      const buffer = await fetch(this.configurationData.pagFile?.url || DEFAULT_PAG_FILE).
        then(response => response?.arrayBuffer());
      // 加载 PAG 素材为 PAGFile 对象
      // this.pagFile = await this.pag?.PAGFile.load(buffer);
      newPagFile = await this.pag?.PAGFile.load(buffer);
      if (this.pagFile) {
        this.pagFile.destroy();
      }
      if (this.pagView) {
        this.pagView.destroy();
      }
      this.pagFile = newPagFile;
      // 动效文件的高/宽比
      this.pagWidth = this.pagFile?.width() ?? 0;
      this.pagHeight = this.pagFile?.height() ?? 0;
      this.pagHWRatio = this.pagHeight / this.pagWidth;
      this.calcPagCanvasSize();
      // 实例化 PAGView 对象
      // 由于 VideoReader 模块在 Web 平台依赖于 VideoElement，所以在部分移动端场景下，PAGView.init 不是在用户交互产生的调用链中，可能会存在不允许播放导致无法正常渲染画面的问题。
      // 当出现这种情况，我们推荐取消首帧渲染
      await this.pag?.PAGView.init(this.pagFile, this.pagCanvas, {
        firstFrame: false,
        useScale: false,
      }).then((response) => {
        // 设置动画循环播放次数：0 代表无限循环
        if (that.pagView) {
          that.pagView?.destroy();
        }
        that.pagView = response;
        const playTime = that.configurationData?.pagDuration || 1000;
        that.pagView.setRepeatCount(playTime / 1000);
      });
      console.log('pagView', that.pagView);
      // 播放 PAGView
      await this.pagView?.play();
      // await this.pagView?.pause();
    },
    calcPagCanvasSize() {
      // 将画布尺寸设置为 PAGFile的尺寸
      this.pagCanvas = document.getElementById(`pag-${this.uid}`);
      if (this.pagCanvas) {
        // 确认已经挂载到 DOM 完毕后再执行尺寸计算
        if (this.styles.base?.width?.endsWith('px')) {
          // pc 页面
          this.pagCanvas.width = parseFloat(this.styles.base?.width) * window.devicePixelRatio;
          this.pagCanvas.height = this.pagCanvas.width * this.pagHWRatio;
        } else if (this.styles.base?.width?.endsWith('rem')) {
          // 移动端页面
          const fontSizeNumber = parseFloat(getComputedStyle(document.documentElement).fontSize);
          const styleWidthNumber = parseFloat(this.styles.base?.width);
          // 将 rem 重新计算成 px 值
          this.pagCanvas.width = fontSizeNumber * styleWidthNumber * window.devicePixelRatio;
          this.pagCanvas.height = this.pagCanvas?.width * this.pagHWRatio;
        } else {
          // 默认
          this.pagCanvas.width = this.pagWidth;
          this.pagCanvas.height = this.pagHeight;
        }
        // 让画布的 css 宽度与组件保持一致
        this.pagCanvas.style.width = this.styles.base?.width ?? this.pagCanvas?.width;
      }
      // 监听 window 大小变化后重新计算画布尺寸
      window.onresize = () => {
        if (this.resizeCoolDown) {
          clearTimeout(this.resizeCoolDown);
          this.resizeCoolDown = null;
        }
        this.resizeCoolDown = setTimeout(() => {
          this.resizePagCanvas();
        }, 300);
      };
    },
    resizePagCanvas() {
      this.calcPagCanvasSize();
      if (this.pagView) {
        this.pagView.updateSize();
        this.pagView.flush();
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
